import { render, staticRenderFns } from "./FishGeneComponent.vue?vue&type=template&id=1ee9ec84&"
import script from "./FishGeneComponent.vue?vue&type=script&lang=ts&"
export * from "./FishGeneComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FishGeneComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports